<template>
  <div id="feedback">
    <!-- <header-top></header-top> -->
    <div class="feedback-form" v-if="!showSuccess">
      <div class="title">反馈问题</div>
      <el-form
        label-position="left"
        label-width="6rem"
        ref="feedbackForm"
        :model="feedbackForm"
        :rules="feedbackRules"
      >
        <el-form-item label="标题" prop="name" class="auto-height">
          <el-input v-model="feedbackForm.name"></el-input>
        </el-form-item>
        <el-form-item label="问题描述" prop="coutent" class="auto-height">
          <el-input
            v-model="feedbackForm.coutent"
            type="textarea"
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="birthday" class="auto-height">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :http-request="getFile"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item prop="birthday">
          <el-button @click="back">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="feedback-form-none" v-else>
      <div class="feedback-box">
        <img src="@/assets/image/feedback.png" alt="" />
        <div class="success">反馈成功</div>
        <div class="tips">
          感谢您对知乐时光的关注与支持，我们会认真处理您的反馈，尽快修复和完善相关功能。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      feedbackForm: {
        name: "",
        coutent: "",
      },
      showSuccess: false,
      fileList: [],
      file: {},
      feedbackRules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    submitForm() {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("Feedback", JSON.stringify(this.feedbackForm));
          if (JSON.stringify(this.file) != "{}") {
            formData.append("File", this.file);
          }
          //console.log(formData, this.feedbackForm);
          setTimeout(() => {
            this.showSuccess = true;
          });
        }
      });
    },
    back() {
      this.$router.push({
        path: `/`,
      });
    },
    getFile(item) {
      this.file = item.file;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#feedback {
  .feedback-form {
    margin: 20px;
    background: #fff;
    .title {
      padding: 20px;
      border-bottom: 1px solid rgba(102, 102, 102, 0.19);
    }
    ::v-deep .el-form {
      padding: 20px 40px;
      .el-input {
        width: 330px;
      }
      .el-textarea {
        width: 550px;
      }
      .el-upload-list__item{
        width: 300px
      }
    }
  }
  .feedback-form-none {
    @include flex(column,center);
    justify-content: center;
    margin: 20px;
    background: #fff;
    text-align: center;
    height: calc(100vh - 90px);
    .feedback-box {
      @include flex(column,center);
      img {
        margin-bottom: 22px;
        width: 250px;
        height: auto;
      }
      .success {
        margin-bottom: 10px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .tips {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
